import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Map, Users, ShieldAlert, Bell, Settings, LayoutGrid, Users as UsersIcon } from "lucide-react";
import { useMembership } from "../lib/membership";

const standardItems = [
  { to: "/dashboard", icon: Map, label: "Map", testid: "nav-map" },
  { to: "/contacts", icon: Users, label: "Contacts", testid: "nav-contacts" },
  { to: "/family", icon: ShieldAlert, label: "Family", testid: "nav-family" },
  { to: "/alerts", icon: Bell, label: "Alerts", testid: "nav-alerts" },
  { to: "/settings", icon: Settings, label: "Settings", testid: "nav-settings" },
];

const eliteItems = [
  { to: "/dashboard", icon: Map, label: "Map", testid: "nav-map" },
  { to: "/hub", icon: LayoutGrid, label: "Hub", testid: "nav-hub" },
  { to: "/contacts", icon: Users, label: "Contacts", testid: "nav-contacts" },
  { to: "/alerts", icon: Bell, label: "Alerts", testid: "nav-alerts" },
  { to: "/settings", icon: Settings, label: "Settings", testid: "nav-settings" },
];

const nodeGroupItems = [
  { to: "/group", icon: UsersIcon, label: "Group", testid: "nav-group" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  const { isEliteMaster, nodeHasGroups } = useMembership();

  let items = standardItems;
  if (nodeHasGroups) items = nodeGroupItems;
  else if (isEliteMaster) items = eliteItems;

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 glass rounded-full px-2 py-2 flex items-center gap-1"
    >
      {items.map(({ to, icon: Icon, label, testid }) => {
        const active = pathname.startsWith(to);
        return (
          <Link
            key={to}
            to={to}
            data-testid={testid}
            className={`group flex flex-col items-center justify-center w-16 py-1.5 rounded-full transition-colors ${
              active ? "text-[#007AFF]" : "text-zinc-400 hover:text-zinc-100"
            }`}
          >
            <Icon size={20} strokeWidth={2.2} />
            <span className="mt-0.5 text-[10px] font-semibold tracking-wide uppercase">
              {label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}
